export const Pricing = [
    {
        type: 'basic',
        description: 'Includes basic usage of our platform. recommended for new and aspiring photographers.',
        price: 19,
        duration: {
            basic: 'month',
            pro: "year"
        },

    },
    {
        type: 'pro',
        description: 'More advanced features available. Recommended for photography veterans abd professionals.',
        price: 39,
        duration: {
            basic: 'month',
            pro: "year"
        },

    },
    {
        type: 'business',
        description: 'Additional features available such as more detailed metrics. Recommended for business owners.',
        price: 99,
        duration: {
            basic: 'month',
            pro: "year"
        },

    },
]